import React from "react";
import { Col, FormGroup, FormLabel } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { Controller, UseFormReturn } from "react-hook-form";
import { EXTRA_USE_MESSAGE, messages } from "../../EditExtra/messages";
import { SelectGroup } from "../SelectGroup";
import { FormType } from "../../EditExtra/types";

export function RateAvailabilityInput({ control, disabled }: UseFormReturn<FormType> & { disabled: boolean }) {
  return <FormGroup as={Col}>
    <FormLabel column sm={12}>
      <FormattedMessage {...messages.availability} />
    </FormLabel>
    <Col sm={3}>
      <Controller
        name="availability"
        control={control}
        render={({ field }) => (
          <SelectGroup optionDisplay={EXTRA_USE_MESSAGE} disabled={disabled} {...field} />
        )}
      />
    </Col>
  </FormGroup>;
}